import { APPLICATIONS_LIMIT } from "./constants";
import { HOLD_REASONS, PORTAL_PRODUCTS } from "./fixtures";
import { withDefaults } from "./detail";
import { live } from "./live";
import type { HoldReason, PortalProduct } from "./types";

/**
 * The one door to the Ops side of the Business portal. Screens call these
 * functions; whether the answer comes from core or from the in-memory mock is
 * decided here, by VITE_BUSINESS_MOCK=1 at build time. The flag is a constant
 * in the build, so without it the mock is never imported and none of its code
 * or data is in the bundle.
 */
export const BUSINESS_MOCK = import.meta.env.VITE_BUSINESS_MOCK === "1";

type Backend = typeof live;
async function backend(): Promise<Backend> {
  // The condition is written out here so the build drops the import, and the mock chunk, when the flag is off.
  if (import.meta.env.VITE_BUSINESS_MOCK === "1") return (await import("./mock")).mock;
  return live;
}

export const createBusiness: Backend["create"] = async (...a) =>
  (await backend()).create(...a);
export const listBusinesses: Backend["list"] = async (...a) =>
  (await backend()).list(...a);
export const getBusiness: Backend["detail"] = async (...a) =>
  withDefaults(await (await backend()).detail(...a));
export const resendInvite: Backend["resendInvite"] = async (...a) =>
  (await backend()).resendInvite(...a);
export const approveReviewItem: Backend["approveItem"] = async (...a) =>
  (await backend()).approveItem(...a);
export const holdReviewItem: Backend["holdItem"] = async (...a) =>
  (await backend()).holdItem(...a);
export const approveBusiness: Backend["approve"] = async (...a) =>
  (await backend()).approve(...a);
export const notApproveBusiness: Backend["notApprove"] = async (...a) =>
  (await backend()).notApprove(...a);

/** portal.products. Fixture until core exposes a read for it (see fixtures.ts). */
export async function listPortalProducts(): Promise<PortalProduct[]> {
  if (import.meta.env.VITE_BUSINESS_MOCK === "1") {
    const { switchOn } = await import("./mock");
    await new Promise((r) => setTimeout(r, 250));
    if (switchOn("products-error")) throw new Error("products");
    if (switchOn("products-none")) return [];
  }
  return PORTAL_PRODUCTS;
}

/** review.hold_reasons. Fixture until core exposes a read for it (see fixtures.ts). */
export async function listHoldReasons(): Promise<HoldReason[]> {
  return HOLD_REASONS;
}

export { APPLICATIONS_LIMIT };
export * from "./types";
export * from "./labels";
export * from "./submitted";
export { BusinessApiError, FALLBACK_WORDS, outcomeUnknown } from "./errors";
